/*
 * @Author: chenzheng
 * @Date: 2019-01-19 16:05:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-06-05 14:33:12
 * @Description: 公共请求接口API
 */

import { get, post } from "@common/http";

// 获取菜单
export const getUserMenu = param =>
    get(`/user/permission/${JSON.parse(window.localStorage.getItem("tenant")).tenantId}`, param)
// 下单中心 状态初始化
export const getOrderInit = param => get(`/order/order-page-init`, param);
/**
 * 获取用户信息
 * @param param
 * @returns {*}
 */
export const getUserContextInfo = param =>
    get(`/uc-service/session/getUserContextInfo`, param);

/**
 * 退出登录
 * @param {*} param
 */
export const logout = param => get(`/uc-service/logout`, param);

/**
 * 获取行政区域
 * @param param
 * @returns {*}
 */
export const getArea = param => post("/uc-service/getArea", param)

/**
 * 上传文件
 * @param param
 * @returns {*}
 */
export const aliUpload = (param, config) =>
    post("/common/ali-upload", param, config);



// WEBPACK FOOTER //
// ./src/api/common.js